export default "__VITE_ASSET__G9hUbxjw__"